module.exports = __webpack_public_path__ + "img/weight-diary.622d813a.png";